<template>
  <section class="menus">
    <van-cell-group class="menus__list">
      <van-cell title="待缴订单" size="large" is-link :to="{name:'Arrears-Bill-Temporary'}" />
      <!-- to="{name:'Arrears-History'}" -->
      <van-cell title="补缴历史" size="large" is-link @click="linkComponents" />
      <van-cell title="补缴帮助" size="large" is-link :to="{name:'Arrears-Bill-Help'}" />
    </van-cell-group>
  </section>
</template>

<script>
import { CellGroup } from 'vant'
export default {
  name: 'Arrears-Bill-Index',
  components: {
    [CellGroup.name]: CellGroup
  },
  data () {
    return {}
  },
  methods: {
    // 跳转
    linkComponents () {
      this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.menus {
  height: 100vh;
  background: #f4f6f7;

  &__list {
    &__icon {
      font-size: 20px;
      line-height: 24px;
      margin-right: 5px;
      height: 24px;
    }
  }
}
</style>